module.exports = __webpack_public_path__ + "media/img/pages/companies/suva-c0ea125ce4b09482be2832db094e97ac.png";